import { animated } from "@react-spring/web";
import classcat from "classcat";
import React from "react";

import { Button, IconBasket } from "@touchtech/web-baselayer-ui";

import css from "./BasketButton.module.css";
import useManageBasketButton from "./hooks/useManageBasketButton";

type Props = {
  onClick: () => void;
  count: number;
  hidden?: boolean;
};

const BasketButton = ({ onClick, count, hidden = false }: Props) => {
  const { styles } = useManageBasketButton({ count });

  return (
    <div className={classcat([css.container, { [css.hidden]: hidden }])}>
      <Button
        onClick={onClick}
        rounded
        variant="primary"
        sizing="base"
        className={css.primaryButton}
      >
        <div className={css.basketIcon}>
          <IconBasket />
          {!!count && (
            <animated.div
              style={styles}
              className={classcat([
                "text-label-base",
                css.quantityContainer,
                css.active,
              ])}
            >
              <div className={css.quantity}>{count}</div>
            </animated.div>
          )}
        </div>
      </Button>
    </div>
  );
};

export default BasketButton;
